import types from "../actions/types";

export const selectAction = () => ({
  type: types.SELECT_BAR,
});
